import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../shared/Card';
import ImageUpload from '../../shared/ImageUpload';
import ImagePreview from '../../shared/ImagePreview';
import {compressImage} from '../../../utils/compressImage';

class CompanyLogo extends React.Component {
  constructor(props) {
    super(props);
    this.onDrop = this.onDrop.bind(this);
    this.onClear = this.onClear.bind(this);
  }

  static get propTypes() {
    return {
      edit: PropTypes.bool,
      logo: PropTypes.object,
      logoDeleted: PropTypes.bool,
      logoBase64: PropTypes.string,
      onLoad: PropTypes.func,
      onClear: PropTypes.func,
      showModalError: PropTypes.func
    }
  }

  onDrop(files, rejectedFiles = []) {
    const file = files && files[0];
    const rejectedFile = rejectedFiles[0];

    if (rejectedFile) {
      this.props.showModalError();
      return;
    }
    if (file) {
      compressImage(file)
        .then((compressedImage) => {
          compressedImage.preview = file.preview;
          this.props.onLoad(compressedImage)});
    }
  }

  onClear() {
    this.props.onClear();
  }

  render() {
    const {
      edit,
      logo,
      logoBase64,
      logoDeleted
    } = this.props;
    return (
      <Card header='Company Logo'>
        <Choose>
          <When condition={edit}>
            <ImageUpload
              base64={logoDeleted ? [null] : [logoBase64]}
              onDrop={this.onDrop}
              onClear={this.onClear}
              files={[logo]}
              showIcon={false}
            />
          </When>
          <Otherwise>
            <div className='text-center'>
              <ImagePreview
                src={logoBase64 ? `data:image/png;base64, ${logoBase64}` : null}
              />
            </div>
          </Otherwise>
        </Choose>
      </Card>
    );
  }
}

export default CompanyLogo;


// WEBPACK FOOTER //
// src/components/companyDetails/CompanyLogo/index.jsx